import { createSelector } from 'reselect'
import { convertData2JsonForm } from '../../../../shared/lib/convertData2JsonForm'
import { objectMap } from '../../../../../lib/utils/get-table-transform-schema-and-form-data'
import { addEnumValBySchema } from '../../../../shared/lib/addEnumValBySchema'

export const createSession = createSelector(
  (state: any) => state.session,
  sessionData => sessionData,
)

const selectAppeals = state => state.appeal

const selectAppealsForm = createSelector(selectAppeals, ({ form }) => form)

const selectAppealsEnums = createSelector(selectAppeals, ({ enums }) => enums)

export const getAppealId = createSelector(selectAppeals, ({ id }) => id)

export const getAppealsFormLoading = createSelector(selectAppealsForm, ({ isLoading }) => isLoading)

export const getAppealsFormError = createSelector(selectAppealsForm, ({ error }) => error)

export const getAppealsFormData = createSelector(selectAppealsForm, ({ data }) => data)

export const getAppealsStageCurrent = createSelector(
  getAppealsFormData,
  formData => formData?.stages?.current,
)

export const getAppealsEnumsData = createSelector(selectAppealsEnums, ({ data }) => data)

export const getAppealsEnumsError = createSelector(selectAppealsEnums, ({ error }) => error)

export const getAppealsEnumsIsLoading = createSelector(
  selectAppealsEnums,
  ({ isLoading }) => isLoading,
)

const selectChatAvito = state => state.chatAvito

export const selectChatAvitoIsLoading = createSelector(
  selectChatAvito,
  ({ isLoading }) => isLoading,
)

export const selectChatAvitoData = createSelector(selectChatAvito, ({ data }) => data)

export const selectChatAvitoError = createSelector(selectChatAvito, ({ error }) => error)

export const getActiveAvitoChatId = createSelector(
  selectChatAvito,
  ({ activeChatId }) => activeChatId,
)

export const getActiveAvitoChat = createSelector(
  [selectChatAvitoData, getActiveAvitoChatId],
  (data, activeChatId) => {
    return data?.filter(chatItem => chatItem.chat_id === activeChatId)[0]
  },
)

export const getVisibleFormData = createSelector(
  [getAppealsFormData, getAppealsEnumsData],
  (formData, enums) => {
    if (formData && enums) {
      const { data: form, customer_id } = formData

      if (!form) {
        return false
      }

      const { resultObject, resultSchema } = convertData2JsonForm(form)

      const enumItems = enums?.['enum'] || []
      if (enums?.['city']) {
        enumItems.city_id = Object.values(
          objectMap(enums['city'], ([key, value]) => [key, { id: parseInt(key), value: value }]),
        )
      }

      if (enums?.['region']) {
        enumItems.region_id = Object.values(
          objectMap(enums['region'], ([key, value]) => [key, { id: parseInt(key), value: value }]),
        )
      }

      Object.keys(enumItems).forEach(code => {
        if (resultSchema?.properties.hasOwnProperty(code)) {
          const enumValues = enums?.['enum']?.[code] || {}
          const oneOf: Record<string, string>[] = []

          Object.keys(enumValues).forEach(enumValue => {
            return oneOf.push({
              const: enumValues[enumValue].id,
              title: enumValues[enumValue].value,
            })
          })

          if (resultSchema?.properties.hasOwnProperty(code)) {
            addEnumValBySchema(resultSchema, code, oneOf, enumValues)
          }

          if (resultObject.hasOwnProperty(code)) {
            resultObject[code] = resultObject[code] ? parseInt(resultObject[code]) : null
          }
        }
      })
      if (resultSchema?.properties.hasOwnProperty('phone')) {
        resultSchema.properties['phone'] = {
          ...resultSchema.properties['phone'],
          options: {
            ...resultSchema.properties['phone'].options,
            customer_id,
          },
        }
      }
      return { resultSchema, resultObject }
    }
  },
)
